module.exports = __webpack_public_path__ + "img/11.50a0ead0.jpg";